// extracted by mini-css-extract-plugin
var _1 = "Table_newItems__OKyql";
var _2 = "Table_table__Wq5yI";
var _3 = "Table_tableContainer__o1Z8q";
export { _1 as "newItems", _2 as "table", _3 as "tableContainer" }
